/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import { connect } from 'react-redux';
import StyledErrorMessage from '../StyledErrorMessage';
import { getSliceContent } from '../../../../selectors';
import theme from '../../../../styles/theme';
import { colourThemeType } from '../../../../propTypes';

export function buildField({ text, html }, id) {
  if (!text) return null;
  return (
    <React.Fragment>
      <Field type="checkbox" id={id} name={id} />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control -- label text is in dangerouslySetInnerHTML */}
      <label htmlFor={id}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </label>
    </React.Fragment>
  );
}
buildField.propTypes = {
  text: PropTypes.string,
  html: PropTypes.string,
};
buildField.defaultProps = {
  text: '',
  html: '',
};

const TCCheckbox = ({
  classes, terms, newsletter, thirdParty, age,
}) => {
  const displayTC = buildField(terms, 'tc');
  const displayNewsletter = buildField(newsletter, 'newsletter');
  const displayThirdParty = buildField(thirdParty, 'thirdParty');
  const displayAge = buildField(age, 'age');

  return (
    <div className={classes.wrapper}>
      {displayTC && (
        <div>
          {displayTC}
          <StyledErrorMessage name="tc" />
        </div>
      )}
      {displayNewsletter && (
        <div>
          {displayNewsletter}
          <StyledErrorMessage name="newsletter" />
        </div>
      )}
      {displayAge && (
        <div>
          {displayAge}
          <StyledErrorMessage name="age" />
        </div>
      )}
      {displayThirdParty && (
        <div>
          {displayThirdParty}
        </div>
      )}
    </div>
  );
};

TCCheckbox.defaultProps = {
  terms: {
    html: '',
    text: '',
  },
  newsletter: {
    html: '',
    text: '',
  },
  thirdParty: {
    html: '',
    text: '',
  },
  age: {
    html: '',
    text: '',
  },
};

TCCheckbox.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  terms: PropTypes.shape({
    html: PropTypes.string,
    text: PropTypes.string,
  }),
  newsletter: PropTypes.shape({
    html: PropTypes.string,
    text: PropTypes.string,
  }),
  thirdParty: PropTypes.shape({
    html: PropTypes.string,
    text: PropTypes.string,
  }),
  age: PropTypes.shape({
    html: PropTypes.string,
    text: PropTypes.string,
  }),
  // eslint-disable-next-line react/no-unused-prop-types -- used in the styles
  colourTheme: colourThemeType.isRequired,
};

const mapStateToProps = (state, { sliceId }) => ({
  terms: getSliceContent(state, sliceId).opt_in_t_c,
  newsletter: getSliceContent(state, sliceId).opt_in_iconic_newsletter,
  thirdParty: getSliceContent(state, sliceId).opt_in_third_party_news,
  age: getSliceContent(state, sliceId).opt_in_age,
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    wrapper: {
      margin: '16px 8px',
      '& div': {
        paddingBottom: '8px',
      },
      '& > div label': {
        display: 'flex',
        color: 'inherit',
        marginBottom: '7px',
        '&::before': {
          minWidth: '16px',
          maxWidth: '16px',
        },
      },
      '& div label p': {
        fontFamily: theme.typography.primaryFontFamily,
        fontSize: '14px',
        margin: '0 0 0 4px',
        color: 'inherit',
        display: 'inline-block',
        lineHeight: 'normal',
        textTransform: 'none',
      },
      '& a, p a:not(.button)[href]': {
        color: 'inherit',
        fontSize: '14px',
        lineHeight: '20px',
        fontFamily: theme.typography.primaryFontFamily,
        textDecoration: 'underline',
      },
      '& a:hover, a:focus, p a:not(.button)[href]:hover, p a:not(.button)[href]:focus': {
        color: ({ colourTheme }) => colourTheme.linkHover,
        textUnderlinePosition: 'initial',
      },
    },
  }),
)(TCCheckbox);
